import React from "react";
import { Box } from "@mui/material";
import UploadLoaderModal from "../modals/UploadLoaderModal";

interface InlineProcessingStatusProps {
  open: boolean;
  files: File[];
  jobId?: string;
  userId?: string;
  onUpload: (
    files: File[],
    progressCallback: (progress: number) => void
  ) => Promise<string>;
  onComplete: (result: string) => void | Promise<void>;
  onTextExtracted?: (text: string) => void;
  onDownloadReady?: (downloadTarget: string) => void;
  onClose?: () => void;
  chatEnabled?: boolean;
  hasDocumentChatAccess?: boolean;
  documentTitle?: string;
  /** Show one progress bar and one friendly status line instead of the step list (audio flows). */
  compact?: boolean;
}

const InlineProcessingStatus: React.FC<InlineProcessingStatusProps> = ({
  open,
  files,
  jobId,
  userId,
  onUpload,
  onComplete,
  onTextExtracted,
  onDownloadReady,
  onClose,
  chatEnabled,
  hasDocumentChatAccess,
  documentTitle,
  compact = false,
}) => {
  return (
    <Box sx={{ mt: open ? 2.5 : 0 }}>
      <UploadLoaderModal
        open={open}
        files={files}
        jobId={jobId}
        userId={userId}
        onUpload={onUpload}
        onComplete={onComplete}
        onTextExtracted={onTextExtracted}
        onDownloadReady={onDownloadReady}
        onClose={onClose}
        variant="inline"
        presentation={compact ? "compact" : "steps"}
        theme="dark"
        maxHeight={480}
        chatEnabled={chatEnabled}
        hasDocumentChatAccess={hasDocumentChatAccess}
        documentTitle={documentTitle}
      />
    </Box>
  );
};

export default InlineProcessingStatus;
